import { guideSteps } from "@/mocks/naruto";

export default function GuideSection() {
  return (
    <section id="guide" className="mx-auto w-full max-w-7xl px-4 py-14 md:py-20">
      <div className="mb-10 text-center">
        <p className="text-sm font-medium text-primary-600">三步上手</p>
        <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">怎样快速找到想看的火影同人本子</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
          从选定CP到收藏作品，三步就能建立起自己的同人本阅读节奏。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {guideSteps.map((step) => (
          <div
            key={step.step}
            className="relative overflow-hidden rounded-lg bg-background-100 p-6 transition-all hover:-translate-y-1"
          >
            <span className="font-display text-5xl text-primary-200">{step.step}</span>
            <div className="mt-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className={`${step.icon} text-xl`}></i>
            </div>
            <h3 className="mt-4 text-lg font-semibold text-foreground-950">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}